//  ==========================================================================
//
//  Our Locations
//
//  ==========================================================================
import React, { PureComponent } from 'react';
import { graphql } from 'gatsby';
import { groupBy, mapValues } from 'lodash';

import { normalizeLocation } from '../helpers/formatters/formatters';

import { HeroStandard, MetaTags, SectionGridWithTitleBar } from '../components';

import { css } from 'emotion';
import styled from 'react-emotion';

import { mq } from '../global-styles';

//  ==========================================================================
//  Styles
//  ==========================================================================
const StyledSectionGroup = styled( 'div' )`
	margin-top: 30px;
	${mq.md(
		css`
			margin-top: 55px;
		`
	)};
	${mq.lg(
		css`
			margin-top: 70px;
		`
	)};
`;

//  ==========================================================================
//  Component
//  ==========================================================================
export default class OurLocations extends PureComponent {
	constructor( props ) {
		super( props );

		const locations = this.props.data.locations.nodes.map( normalizeLocation );

		this._locationsByRegion = mapValues(
			groupBy( locations, location => location.region )
		);

		this._ourLocationsData = {
			description:
				props.data.allWordpressWpStaticPageMeta.edges[0].node
					.our_locations_meta_desc,
			hero: props.data.heroImage?.childImageSharp?.fluid,
			heroAlt:
				'Image of a red arch with buildings behind it and an american flag in the middle',
			locationsAsiaPacific: this._locationsByRegion.ap,
			locationsEuropeMiddleEastNorthAfrica: this._locationsByRegion.eu,
			locationsLatinAmerica: this._locationsByRegion.la,
			locationsAmericasWest: this._locationsByRegion.aw,
			locationsAmericasCentral: this._locationsByRegion.ac,
			locationsAmericasEast: this._locationsByRegion.ae,
		};
	}

	render() {
		const {
			description,
			hero,
			heroAlt,
			locationsAsiaPacific,
			locationsEuropeMiddleEastNorthAfrica,
			locationsLatinAmerica,
			locationsAmericasWest,
			locationsAmericasCentral,
			locationsAmericasEast,
		} = this._ourLocationsData;

		return (
			<main id="main">
				<MetaTags post_title="Our Locations" description={description} />

				<HeroStandard
					hero={hero}
					heroAlt={heroAlt}
					label="Our Locations"
					post_title="We are an international design firm that believes great design begins at the local level."
					description="Our offices share resources and expertise around the globe and across disciplines, offering a local portal into our global network of design expertise and insights."
				/>

				<StyledSectionGroup className="content-contain">
					<div className="content-contain__interior-lvl-one">
						<SectionGridWithTitleBar
							post_title="Asia & Pacific"
							content={locationsAsiaPacific}
							contentType="locations"
							customClass="mobile-one-column"
						/>
						<SectionGridWithTitleBar
							post_title="Europe, Middle East & North Africa"
							content={locationsEuropeMiddleEastNorthAfrica}
							contentType="locations"
							customClass="mobile-one-column"
						/>
						<SectionGridWithTitleBar
							post_title="Latin America"
							content={locationsLatinAmerica}
							contentType="locations"
							customClass="mobile-one-column"
						/>
						<SectionGridWithTitleBar
							post_title="Americas East"
							content={locationsAmericasEast}
							contentType="locations"
							customClass="mobile-one-column"
						/>
						<SectionGridWithTitleBar
							post_title="Americas Central"
							content={locationsAmericasCentral}
							contentType="locations"
							customClass="mobile-one-column"
						/>
						<SectionGridWithTitleBar
							post_title="Americas West"
							content={locationsAmericasWest}
							contentType="locations"
							customClass="mobile-one-column"
						/>
					</div>
				</StyledSectionGroup>
			</main>
		);
	}
}

export const ourLocationsQuery = graphql`
	query OurLocationsQuery {
		allWordpressWpStaticPageMeta: allWordsbyCollections(
			filter: { post_type: { eq: "static_page_meta" } }
		) {
			edges {
				node {
					our_locations_meta_desc
				}
			}
		}
		locations: allWordsbyCollections(
			filter: {
				post_type: { eq: "location" }
				post_title: { regex: "/^((?!Test Location).)*$/" }
			}
			sort: { fields: [post_title], order: ASC }
		) {
			nodes {
				...PostFields
				...HeroComponent

				...ThumbnailFields

				business_contact {
					relationshipByID {
						...PersonFields
					}
				}
				addresses {
					building_name
					address_1
					address_2
					map_url
				}
				phone
				description
				region
				short_summary
				video
				grid_heading
				grid {
					relationshipByID {
						...CardComponent
					}
					post_type
					post_status
				}
			}
		}
		heroImage: file(relativePath: { regex: "/OurLocations-Hero-2020.jpg/" }) {
			childImageSharp {
				fluid(maxWidth: 2880) {
					...GatsbyImageSharpFluid_noBase64
				}
			}
		}
	}
`;
